import {useAgentsFromGroup, useUserInfo} from '../../hooks';
import {DashboardPage} from './DashboardPage';

export const DashboardPagePortal = () => {
  const {uid, groupRole, userGroupId} = useUserInfo();
  const {
    documents: {data: agents},
  } = useAgentsFromGroup(uid, userGroupId, groupRole);
  return <DashboardPage agents={agents} />;
};
